export const refundsSection = '/refunds';

export const refundsPath = refundsSection;

export const refundDetailPath = (id: string) => `${refundsPath}/${id}`;
export const refundDetailRoute = `${refundsPath}/:id`;

export const refundDeclinePath = (id: string) => `${refundsPath}/${id}/decline`;
export const refundDeclineRoute = `${refundsPath}/:id/decline`;